import React, { useState, useEffect, useRef } from 'react';

const SocialSection = () => {

    const openInstagram = () => {
        window.open('https://instagram.com/escuelaveronicadandrea', '_blank');
    };

    const openWhatsApp = () => {
        window.open('https://wa.me/59894075255?text=Hola, me interesa obtener más información sobre la escuela', '_blank');
    };

    const openFacebook = () => {
        window.open('https://www.facebook.com/escuelaveronicadandrea', '_blank');
    };

    return (
            <section className="py-20 bg-black relative overflow-hidden">
            {/* Simple Background Pattern */}
            <div className="absolute inset-0">
                <div className="absolute inset-0 bg-black"></div>
                <div className="absolute bottom-0 left-0 w-full h-2/3 bg-gradient-to-tr from-amber-900/20 to-transparent rounded-full blur-3xl"></div>
                <div className="absolute top-1/4 right-0 w-3/5 h-2/5 bg-gradient-to-bl from-amber-800/25 to-transparent rounded-full blur-2xl"></div>
            </div>

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                {/* Header */}
                <div className={`text-center mb-16 transition-all duration-1000`}>
                    <span className="inline-block bg-primary text-white px-6 py-2 rounded-full text-sm font-medium mb-6">
                        Síguenos
                    </span>
                    <h2 className="text-4xl lg:text-5xl font-light text-white mb-4">
                        Conecta con <span className="text-primary">Nosotros</span>
                    </h2>
                    <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                        Mantente al día con nuestras últimas noticias y trabajos destacados
                    </p>
                </div>

                <div className="grid lg:grid-cols-3 gap-12">
                    {/* Social Media Feeds */}
                    <div className={`lg:col-span-2 transition-all duration-1000 delay-200`}>
                        {/* Instagram Section */}
                        <div className="mb-8">
                            <div className="flex items-center justify-between mb-6">
                                <h3 className="text-2xl font-light text-white">
                                    Nuestro <span className="text-primary">Instagram</span>
                                </h3>
                                <button
                                    onClick={openInstagram}
                                    className="flex items-center space-x-2 text-primary hover:text-primary-light transition-colors duration-300"
                                >
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.40s-.644-1.44-1.439-1.40z" />
                                    </svg>
                                    <span>@escuelaveronicadandrea</span>
                                </button>
                            </div>

                            {/* Instagram Profile Embed */}
                            <div className="bg-zinc-900/80 backdrop-blur-sm rounded-2xl p-6 border border-zinc-700/50 mb-8">
                                <iframe
                                    src="https://www.instagram.com/escuelaveronicadandrea/embed"
                                    width="100%"
                                    height="500"
                                    frameBorder="0"
                                    scrolling="no"
                                    allowTransparency={true}
                                    className="rounded-lg"
                                    title="Instagram Profile"
                                />
                            </div>
                        </div>

                        {/* Facebook Section */}
                        <div className="mb-8">
                            <div className="flex items-center justify-between mb-6">
                                <h3 className="text-2xl font-light text-white">
                                    Nuestro <span className="text-blue-500">Facebook</span>
                                </h3>
                                <button
                                    onClick={openFacebook}
                                    className="flex items-center space-x-2 text-blue-500 hover:text-blue-400 transition-colors duration-300"
                                >
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                    </svg>
                                    <span>@escuelaveronicadandrea</span>
                                </button>
                            </div>

                            {/* Facebook Page Embed */}
                            <div className="bg-zinc-900/80 backdrop-blur-sm rounded-2xl p-6 border border-zinc-700/50 mb-8">
                                <div className="w-full overflow-hidden">
                                    <iframe
                                        src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fescuelaveronicadandrea&tabs=timeline&width=800&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                        width="100%"
                                        height="600"
                                        style={{
                                            border: 'none',
                                            overflow: 'hidden',
                                            width: '100%',
                                            maxWidth: '100%',
                                            display: 'block',
                                        }}
                                        frameBorder="0"
                                        scrolling="no"
                                        allowTransparency={true}
                                        allow="encrypted-media"
                                        className="rounded-lg"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Cards */}
                    <div className={`lg:col-span-1 flex flex-col space-y-4 transition-all duration-1000 delay-400`}>
                        {/* Instagram Follow Card */}
                        <div className="bg-zinc-900/80 backdrop-blur-sm rounded-2xl p-6 border border-zinc-700/50 hover:border-primary transition-all duration-500 flex-1 flex flex-col">
                            <div className="text-center flex-1 flex flex-col">
                                <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center mx-auto mb-4">
                                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.40s-.644-1.44-1.439-1.40z" />
                                    </svg>
                                </div>

                                <div className="flex-1 flex flex-col justify-center">
                                    <h3 className="text-lg font-medium text-white mb-2">Síguenos en Instagram</h3>
                                    <p className="text-gray-300 text-sm mb-6">
                                        Trabajos increíbles y técnicas nuevas
                                    </p>
                                </div>

                                <button
                                    onClick={openInstagram}
                                    className="w-full py-3 px-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-medium hover:from-purple-600 hover:to-pink-600 transition-all duration-300 hover:scale-105 rounded-xl"
                                >
                                    Seguir
                                </button>
                            </div>
                        </div>

                        {/* Facebook Follow Card */}
                        <div className="bg-zinc-900/80 backdrop-blur-sm rounded-2xl p-6 border border-zinc-700/50 hover:border-blue-500 transition-all duration-500 flex-1 flex flex-col">
                            <div className="text-center flex-1 flex flex-col">
                                <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                    </svg>
                                </div>

                                <div className="flex-1 flex flex-col justify-center">
                                    <h3 className="text-lg font-medium text-white mb-2">Síguenos en Facebook</h3>
                                    <p className="text-gray-300 text-sm mb-6">
                                        Noticias y actualizaciones
                                    </p>
                                </div>

                                <button
                                    onClick={openFacebook}
                                    className="w-full py-3 px-4 bg-blue-600 text-white font-medium hover:bg-blue-700 transition-all duration-300 hover:scale-105 rounded-xl"
                                >
                                    Seguir
                                </button>
                            </div>
                        </div>

                        {/* WhatsApp Contact Card */}
                        <div className="bg-zinc-900/80 backdrop-blur-sm rounded-2xl p-6 border border-zinc-700/50 hover:border-green-500 transition-all duration-500 flex-1 flex flex-col">
                            <div className="text-center flex-1 flex flex-col">
                                <div className="w-16 h-16 bg-green-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.884 3.703" />
                                    </svg>
                                </div>

                                <div className="flex-1 flex flex-col justify-center">
                                    <h3 className="text-lg font-medium text-white mb-2">Contáctanos</h3>
                                    <p className="text-gray-300 text-sm mb-6">
                                        Resuelve todas tus dudas
                                    </p>
                                </div>

                                <button
                                    onClick={openWhatsApp}
                                    className="w-full py-3 px-4 bg-green-600 text-white font-medium hover:bg-green-700 transition-all duration-300 hover:scale-105 rounded-xl"
                                >
                                    Chatear por WhatsApp
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SocialSection; 